import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=76b57d2f"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports